import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rrhh-alta-remax',
  templateUrl: './rrhh-alta-remax.component.html',
  styleUrls: ['./rrhh-alta-remax.component.scss']
})
export class RrhhAltaRemaxComponent implements OnInit {

  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.change.emit(true);
  }

}
